import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ManageFollowup = () => {

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [loading, setLoading] = useState(false);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [responses, setres] = useState([]);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = (filter = {}) => {
        setLoading(true);
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/leadfollowup/today`, { params: params })
            .then(response => {
                setData(response.data.data);
                setres(response.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    const [key, setKey] = useState('today_followup');

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            // Determine AM or PM
            const ampm = hour >= 12 ? 'PM' : 'AM';

            // Convert hour from 24-hour to 12-hour format
            hour = hour % 12;
            if (hour === 0) hour = 12; // the hour '0' should be '12'

            // Return formatted string without seconds (optional)
            return `${hour}:${minute} ${ampm}`;
        } else {
            return '';
        }
    };
    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "managefollowup"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    // if (loading) {
    //     return <div>Loading...</div>; // optional loading state
    // }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage FollowUp </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Today's Followup</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>
                </div>
            )}

            {permissions.followup_list === 1 && (
                <Row>
                    <Col xl={12} className='mb-3'>
                        <div className="custom-tab-1">
                            <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>

                                {loading ? (
                                    <Nav as="ul" className="nav-tabs">
                                        {[1, 2, 3, 4].map((_, index) => (
                                            <Nav.Item as="li" key={index}>
                                                <Nav.Link disabled className="d-flex align-items-center">

                                                    <Skeleton circle width={20} height={20} />

                                                    <div className="ms-2">
                                                        <Skeleton width={80} height={14} />
                                                    </div>

                                                    <div className="ms-2">
                                                        <Skeleton width={30} height={18} borderRadius={12} />
                                                    </div>
                                                </Nav.Link>
                                            </Nav.Item>
                                        ))}
                                    </Nav>
                                ) : (
                                    <Nav as="ul" className="nav-tabs">
                                        <Nav.Item as="li" >
                                            <Nav.Link eventKey="today_followup">
                                                <i class="fa-solid fa-calendar-day"></i>
                                                <label className="ms-2 fs-6">
                                                    Today Followup
                                                </label>
                                                <Badge as="a" href="" bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                                    {responses.today_followup_count}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-closed-followup">
                                                <i class="fa-solid fa-calendar-minus"></i>
                                                <label className="ms-2 fs-6">
                                                    Closed Followup
                                                </label>
                                                <Badge as="a" href="" bg=" badge-circle" className='badge-outline-success ms-2 fw-bold fs-8'>
                                                    {responses.closed_followup_count}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-reschedule-followup">
                                                <i class="fa-solid fa-calendar-plus"></i>
                                                <label className="ms-2 fs-6">
                                                    Reschedule Followup
                                                </label>
                                                <Badge as="a" href="" bg=" badge-circle" className='badge-outline-warning ms-2 fw-bold fs-8'>
                                                    {responses.reschedule_followup_count}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-unfollowup">
                                                <i class="fa-solid fa-calendar-xmark"></i>
                                                <label className="ms-2 fs-6">
                                                    Un Followup
                                                </label>
                                                <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                                    {responses.unfollowup_count}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                )}

                                <Tab.Content className="pt-4">
                                    <Tab.Pane eventKey="today_followup">
                                        <Row>
                                            <Col xl={12}>

                                                {loading ? (
                                                    <div className="table-container">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <div className="d-flex align-items-center">
                                                                <Skeleton width={40} height={12} className="me-2" />
                                                                <Skeleton width={60} height={28} borderRadius={4} />
                                                            </div>

                                                            <Skeleton width={180} height={36} borderRadius={4} />
                                                        </div>

                                                        <table
                                                            className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                                                            style={{ borderBottom: "2px solid #ddd" }}
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th><Skeleton width={100} height={16} /></th>
                                                                    <th><Skeleton width={100} height={16} /></th>
                                                                    <th><Skeleton width={100} height={16} /></th>
                                                                    <th><Skeleton width={100} height={16} /></th>
                                                                    <th><Skeleton width={100} height={16} /></th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {[...Array(25)].map((_, rowIndex) => (
                                                                    <tr key={rowIndex}>
                                                                        <td>
                                                                            <Skeleton width={120} height={14} />
                                                                        </td>

                                                                        <td className="text-start">
                                                                            <Skeleton width={100} height={14} />
                                                                        </td>

                                                                        <td className="text-start">
                                                                            <Skeleton width={100} height={14} />
                                                                            <div className="mt-1">
                                                                                <Skeleton width={70} height={10} />
                                                                            </div>
                                                                        </td>

                                                                        <td className="text-start">
                                                                            <Skeleton width={140} height={12} />
                                                                            <div className="mt-1">
                                                                                <Skeleton width={100} height={10} />
                                                                            </div>
                                                                        </td>

                                                                        <td className="text-center">
                                                                            <Skeleton width={100} height={20} borderRadius={10} />
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>

                                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                                            <Skeleton width={200} height={12} />

                                                            <div className="d-flex align-items-center gap-2">
                                                                {[1, 2, 3, 4].map((_, index) => (
                                                                    <Skeleton
                                                                        key={index}
                                                                        width={40}
                                                                        height={26}
                                                                        borderRadius={4}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="table-container">

                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            {/* Left: Show entries dropdown */}
                                                            <div>
                                                                <label className="me-2">Show</label>
                                                                <select
                                                                    className="form-select d-inline w-auto"
                                                                    style={{ fontSize: '0.85rem', height: '30px' }}
                                                                    value={perPage}
                                                                    onChange={(e) => {
                                                                        setPerPage(Number(e.target.value));
                                                                        setPage(1); // Reset to first page
                                                                    }}
                                                                >
                                                                    <option value={10}>10</option>
                                                                    <option value={25}>25</option>
                                                                    <option value={50}>50</option>
                                                                    <option value={100}>100</option>
                                                                </select>
                                                            </div>

                                                            {/* Right: Search input */}
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    style={{ fontSize: '0.85rem', height: '40px' }}
                                                                    placeholder="Search..."
                                                                    className="form-control"
                                                                    value={searchTerm}
                                                                    onChange={(e) => {
                                                                        setSearchTerm(e.target.value);
                                                                        setPage(1); // Reset page on new search
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <table style={{ borderBottom: '2px solid #ddd' }} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                            <thead>
                                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                                    <th className='min-w-125px'>Lead & Mobile Number</th>
                                                                    <th className='min-w-100px text-start'>Date & Time</th>
                                                                    <th className='min-w-125px'>Followed By</th>
                                                                    <th className='min-w-100px'>Followup Status</th>
                                                                    <th className='min-w-125px text-center'>Comment</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                                {datas.length === 0 && hasFetched ? (
                                                                    <tr>
                                                                        <td colSpan="5" className="text-center text-muted py-2">
                                                                            No data available
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    <>
                                                                        {datas.map((data, index) => (
                                                                            <tr key={data.sno}>
                                                                                <td>
                                                                                    <div className='text-black font-w400 fs-7 text-wrap mw-75'>{capitalizeFirstLetter(data.lead_name)}</div>
                                                                                    <div className='d-block text-start  font-w500 fs-7 text-wrap mw-75 text-primary'>{data.lead_mobile}</div>
                                                                                </td>
                                                                                <td>
                                                                                    <div className='text-start text-black font-w400 fs-7 text-wrap mw-75'>{formatDate(data.appointment_date)}</div>
                                                                                    <div className='d-block text-start text-primary font-w500 fs-7 text-wrap mw-75'>{convert24to12(data.appointment_time)}</div>
                                                                                </td>
                                                                                <td>
                                                                                    <div className='text-start text-black font-w400 fs-7 text-wrap mw-75'>{data.followed_by}</div>
                                                                                    <div className='d-block text-start text-primary font-w500 fs-7 text-wrap mw-75'>{data.followed_by_position}</div>
                                                                                </td>
                                                                                <td>
                                                                                    <span class="badge border border-danger bg-transparent text-danger fs-8 font-w400 mw-75">Pending</span>
                                                                                </td>
                                                                                <td className='text-center'>
                                                                                    <span class="text-start text-black font-w400 fs-7 text-wrap mw-75">{data.comments}</span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </>
                                                                )}
                                                            </tbody>
                                                        </table>

                                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                                            {/* Bottom left: Showing x to y of z entries */}
                                                            <div>
                                                                {datas.length > 0 ? (
                                                                    <span className="text-muted">
                                                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-muted">
                                                                        Showing 0 to 0 of 0 entries
                                                                    </span>
                                                                )}
                                                            </div>

                                                            {/* Bottom right: Pagination */}
                                                            <nav>
                                                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                                    </li>
                                                                    {[...Array(totalPages)].map((_, i) => (
                                                                        <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                                        </li>
                                                                    ))}
                                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                                    </li>
                                                                </ul>
                                                            </nav>

                                                        </div>
                                                    </div>
                                                )}

                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </Col>
                </Row>
            )}

            {permissions.followup_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}
        </>
    )

}
export default ManageFollowup;